import React from 'react'
import {ISegmentModel} from './SegmentModel'
import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'

type Props = {
  data: ISegmentModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (segment: ISegmentModel) => void
  onDelete?: (segment: ISegmentModel) => void
  loading?: boolean
}

export const SegmentTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const columns: TableColumn<ISegmentModel>[] = [
    {key: 'name', label: 'Segment Adı', className: 'fw-semibold'},
  ]

  const actions: TableAction<ISegmentModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (segment) => onEdit?.(segment),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (segment) => onDelete?.(segment),
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      loading={loading}
      emptyMessage='Henüz segment bulunamadı'
    />
  )
}
